import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Validators} from "@angular/forms";
import {AppQuestion} from "../../../javascript.lib.mojo-base/model/AppQuestion";
import {ValueHelper} from "../../../javascript.lib.mojo-base/util/ValueHelper";
import {AppAnswer} from "../../../javascript.lib.mojo-base/model/AppAnswer";
import {LoggerFactory} from "../../../javascript.lib.mojo-base/log/LoggerFactory";
import {BaseQuestion} from "../BaseQuestion";

@Component({
  selector: 'question-centimeters',
  templateUrl: 'question-centimeters.html',
  styleUrls: ['question-centimeters.scss']
})

export class QuestionCentimetersComponent extends BaseQuestion implements OnInit, OnDestroy {

  _log = LoggerFactory.build( 'QuestionCentimetersComponent' );

  @Input() required: boolean = true;

  @Input() set disabled(value: boolean) {
    super.disabled = value;
    if( value ) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }


  hasIssues(): boolean {
    if( !this.required ) {
      return false;
    }

    if( this.formControl.disabled ) {
      return false;
    }

    if( null === this.formControl.errors ) {
      return false;
    } else {
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
    }

    return true;
  }

  set model( value: string ) {
    const numberValue = ValueHelper.valueToNumber(value)

    this._log.debug('value', value);
    if( null === numberValue ) {
      this.answer.answer.value.value = null;
      this.answer.answer.value.hasAnswer = false;
    } else {
      this.answer.answer.value.value = numberValue;
      this.answer.answer.value.hasAnswer = true;
    }

    // hack to trigger any subjects the may have subscribed to updates ...
    this.answer.answer.value = this.answer.answer.value;
  }

  get model() {
    return this.answer.answer.value.value;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.validateType(AppQuestion.TYPE_CM_MEASUREMENT);

    {
      const validators = [
        Validators.min(this.answer.question.value.typicalLowValue ?? 0),
        Validators.max(this.answer.question.value.typicalHighValue),
      ];
      if( this.required ) {
        validators.push( Validators.required );
      }
      this.formControl.setValidators( validators );
    }

    const dependantAnswer = this.answer.dependant;

    if( dependantAnswer ) {
      this._dependantSubscription = dependantAnswer.getSubject().subscribe( (dependant: AppAnswer ) => {
        const isTruthy = dependant.isTruthy(this.answer.question.value.dependant);
        this._log.debug('isTruthy', isTruthy);
        this.disabled = !isTruthy;
      } );
    }

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  constructor() {
    super();
  }
}
